<template>
  <div class="d-flex">
    <CompleteMissionModal v-if="isKid && !isMissionVerified && !isMissionExpired && !isMissionCompleted" :missionId="mission.id" />
    <div v-if="isKid && isMissionCompleted && !isMissionVerified" class="text-capitalize">waiting for verification</div>
    <VerifyMissionModal v-if="isParent && isMissionCompleted && !isMissionVerified" :missionId="mission.id" />
    <RejectMissionModal v-if="isParent && isMissionCompleted && !isMissionVerified" :missionId="mission.id" />
    <ExtendMissionModal v-if="isParent && !isMissionCompleted && !isMissionVerified" :missionId="mission.id" />
    <DeleteMission v-if="isParent && !isMissionCompleted && !isMissionVerified" @click.prevent="remove" :missionId="mission.id" />
    <RestoreMissionModal v-if="isParent && isMissionVerified" :missionId="mission.id" />
  </div>
</template>

<script>
  import ExtendMissionModal from "./ExtendMissionModal";
  import RestoreMissionModal from "./RestoreMissionModal";
  import CompleteMissionModal from "./CompleteMissionModal";
  import VerifyMissionModal from "./VerifyMissionModal";
  import RejectMissionModal from "./RejectMissionModal";
  import DeleteMission from "./DeleteMission";

  export default {
    name: "MissionActions",

    props: {
      mission: {
        type: Object,
        required: true,
      },
    },

    components: {
      ExtendMissionModal,
      RestoreMissionModal,
      CompleteMissionModal,
      VerifyMissionModal,
      RejectMissionModal,
      DeleteMission,
    },

    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
      isKid() {
        return this.$store.getters.userInfo.role === "child";
      },
      isParent() {
        return this.$store.getters.userInfo.role === "parent";
      },
      isMissionCompleted: {
        get() {
          return this.$store.getters.findMissionById(this.mission.id).complete;
        },
        set(value) {
          this.$store.commit("toggleMissionCompletion", this.mission.id);
        },
      },
      isMissionExpired() {
        if (this.mission.due_date) {
          return this.$moment().format("YYYY-MM-DD") > this.$moment(this.mission.due_date).format("YYYY-MM-DD");
        } else {
          return false;
        }
      },
      isMissionVerified() {
        return this.mission.verified;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Mission/MissionActions.vue